import { Skeleton, Stack } from '@mui/material';

export const CategoryChipSkeleton = () => (
  <Stack direction="row" spacing={1} sx={{ my: 2 }}>
    {[...Array(12)].map((_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        width={80}
        height={32}
        sx={{ borderRadius: '16px', flexShrink: 0 }}
      />
    ))}
  </Stack>
);
